import axios from 'axios';

// get module api
export async function getModulesAPI() {
	let modulelist = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/roleAccess/getModule`,
			// data: {},
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		modulelist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return modulelist;
}

// get module access api
export async function getModuleAccessAPI() {
	let moduleAccesslist = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/roleAccess/getModuleAccess`,
			// data: {},
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		moduleAccesslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return moduleAccesslist;
}

// get role module access api
export async function getRoleModuleAccessAPI(roleID) {
	let resultlist = [];

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/roleAccess/getRoleModuleAccess/${roleID}`,
			// data: {},
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		resultlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return resultlist;
}

//create roles access api
export async function createRoleAccessAPI(Data, roleID, userID) {
	let roleAccessData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}system/roleAccess/create/`,
			data: {Data, roleID, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		roleAccessData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return roleAccessData;
}

//update roles api
export async function updateRoleAccessAPI(accessCode, roleID, userID) {
	console.log('data access', accessCode)
	let roleData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/roleAccess/update`,
			data: {accessCode, roleID, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		roleData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return roleData;
}